module.exports = __webpack_public_path__ + "img/pic_contacts_nodata.00fb42bf.png";